<template>
  <TeamsTable />
</template>

<script>
import TeamsTable from '@/components/TeamsTable.vue';

export default {
  components: {
    TeamsTable,
  },
};
</script>
